import React,{ useState, useEffect   } from 'react'
import Table from 'react-bootstrap/Table';
import { FaPlusCircle, FaEdit, FaTrash } from 'react-icons/fa';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { useSignalAbort } from '../../api/useSignalAbort';
import { handleApiErrors } from "../../api/handleApiErrors";
import * as successApi from './../../api/successApi';
import { Spinner } from 'react-bootstrap';
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const defaultSuccessDetails = {
  Title: '',
  Content: '',
  Image: '',
  ExternalUrl: '',
  IsActive: 1,
   
}

 function SuccessStory() {
  const abortConstants = useSignalAbort()
  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [successDetails, setSuccessDetails] = useState(defaultSuccessDetails);
  const [successList, setSuccessList] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [successStoryToDelete, setSuccessStoryToDelete] = useState(null);

  const [validated, setValidated] = useState(false);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    getAllData(abortConstants.controllerConfig)
  },[])


  const getAllData = (abortToken) => {
    getAllSuccessStory(abortToken)
  }

//Bloglist
const getAllSuccessStory = async (abortToken) => {
  try {
     const result = await successApi.getSuccessStory(abortToken)
    
     setSuccessList(result.data.SuccessStories)
    console.log(result.data.SuccessStories);
  }
  catch (error) {
     console.log(error);
     handleApiErrors(error, 'SuccessStoryListing', 'successStoryListing_response', 'successStoryListing_timeout', 'successStoryListing_request', setIsLoading);

  }
}


//for add job api call
const createSuccessStory = async (data,abortToken) => {
  console.log(data);
  try {
     const result = await successApi.createSuccessStory(data,abortToken)
     if(result){
      setIsLoading(false);
      setSuccessList(null)
      getAllSuccessStory(abortConstants.controllerConfig)
    }

    //  toast.success(result.data.message)
    toast.success("SuccessStory created successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });
    
    console.log(result);
  }
  catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'SuccessStoryListing', 'successStoryListing_response', 'successStoryListing_timeout', 'successStoryListing_request', setIsLoading);
    setIsLoading(false);

   }
}

//for   UPDATE api call
const updateSuccessStory = async (id,data,abortToken) => {
  console.log("edit",id,data);
  try {
     const result = await  successApi.updateSuccessStory(id,data,abortToken)
     
     if(result){
      setIsLoading(false);
      setSuccessList(null)
      getAllSuccessStory(abortConstants.controllerConfig)
    }
//  toast.success(result.data.message)
toast.success("SuccessStory updated successfully!", {
autoClose: 5000, // Close the toast after 5 seconds
});
     console.log(result);

  }
  catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'SuccessStoryListing', 'successStoryListing_response', 'successStoryListing_timeout', 'successStoryListing_request', setIsLoading);
    setIsLoading(false);

  }
}


const deleteSuccessStory = async (id) => {
  setSuccessStoryToDelete(id);
  setShowDeleteModal(true);
};

const handleDeleteSuccessStory = async () => {
  try {
    await successApi.deleteSuccessStory(successStoryToDelete);
    const updatedSuccessStoryList = successList.filter((success) => success.Id !== successStoryToDelete,abortConstants.controllerConfig);
    
    //  toast.success(result.data.message)
    toast.success("SuccessStory deleted successfully!", {
      autoClose: 5000, // Close the toast after 5 seconds
    });

    setSuccessList(updatedSuccessStoryList);
    setShowDeleteModal(false);
  } catch (error) {
    console.log(error);
    toast.error(error)
    handleApiErrors(error, 'SuccessStoryListing', 'successStoryListing_response', 'successStoryListing_timeout', 'successStoryListing_request', setIsLoading);

  }
};


const handleCancelDelete = () => {
  setShowDeleteModal(false);
  setSuccessStoryToDelete(null);
};


// Handle image change
// const handleLogoChange = (e) => {
//   const file = e.target.files[0];
//   const reader = new FileReader();

//   reader.onload = () => {
//     try {
//       const base64Data = reader.result.split(',')[1]; // Get base64 data excluding the data URI scheme
//       setSuccessDetails({
//         ...successDetails,
//         Image: base64Data
       
//       });
//      } catch (error) {
//       console.error('Error handling image data:', error);
//       // Handle the error (e.g., show an error message to the user)
//     }
//   };

//   reader.readAsDataURL(file);
//   setSelectedLogo(file);
// };
const handleLogoChange = (e) => {
  const file = e.target.files[0];
  const reader = new FileReader();

  reader.onload = () => {
    try {
      const base64Data = reader.result.split(',')[1];
      // Check if the base64Data is valid
      if (/^[a-zA-Z0-9+/]*={0,2}$/.test(base64Data)) {
        setSuccessDetails({
          ...successDetails,
          Image: base64Data
        });
        setSelectedLogo(reader.result); // Update selectedLogo with the data URL
      } else {
        console.error('Invalid base64 data');
      }
    } catch (error) {
      console.error('Error handling image data:', error);
    }
  };

  reader.readAsDataURL(file);
};



 // Toggle add modal
 const toggleAddModal = () => {
  setShowAddModal(!showAddModal);
  if (!showAddModal) {
    resetSuccessStoryDetails();
  }
};

  // Handle input change in success details
  const handleChange = (e) => {
    if (e.target.name === 'IsActive') {
      setSuccessDetails({ ...successDetails, IsActive: e.target.checked ? 1 : 0 });
    } else {
      setSuccessDetails({ ...successDetails, [e.target.name]: e.target.value });
    }
  };


// Toggle edit modal
const toggleEditModal = (index) => {
  console.log(index);
  const success_id = successList[index]?.Id
  
  setEditIndex(success_id);
  if (!showEditModal) {
    setSuccessDetails(successList[index]); 
    setSelectedLogo(`${process.env.REACT_APP_BASE_URL}${successList[index]?.Image}`)

  }
      setShowEditModal(!showEditModal);
      console.log(successList[index]);
};
console.log(successDetails);

 
// Reset job details
 const resetSuccessStoryDetails = () => {
  setSuccessDetails(defaultSuccessDetails); // Reset to default values
  setSelectedLogo(null);
};

// Handle add form submit
const handleSubmit = (e) => {
  setIsLoading(true);

  e.preventDefault();
const form = e.currentTarget;
  
if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...successDetails,
  }

console.log(newData);
console.log(selectedLogo);

const handleCreateSuccessStory = async () => {
    try {
      await createSuccessStory(newData,abortConstants.controllerConfig);
      toggleAddModal(); // Close the modal
      setSuccessList([...successList,newData]);
    } catch (error) {
      console.log(error);
    }
  };

  handleCreateSuccessStory(); // Call the asynchronous function
};


// Handle Edit form submit
const handleEditSubmit = async  (e) => {
  setIsLoading(true);

  e.preventDefault();

  const form = e.currentTarget;
  
  if (form.checkValidity() === false) {
    e.stopPropagation();
    setValidated(true);
    setIsLoading(false);

    return;
  }

  let newData = {
    ...successDetails,
     
  }
  console.log(successDetails);

  try {
    // Send request to update blog data in the backend
    await updateSuccessStory(editIndex, newData,abortConstants.controllerConfig);

    // Update local state (jobList) with the edited data
    const updatedSuccessStoryList = successList.map((success, index) =>
      index === editIndex ? newData : success
    );
    setSuccessList(updatedSuccessStoryList);

    // Close the edit modal
    toggleEditModal();
  } catch (error) {
    console.log(error);
  }
};

const renderLoading = (item) => {
  if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`]) {
    return true;
  } else {
    return false;
  }
}

  
return (
  <div style={{margin :'20px' ,width:'100%'}}>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <h2 style={{ fontSize: '1.5rem', marginBottom: '0' }}>Success Stories</h2>
    <FaPlusCircle size={24} style={{ marginBottom: '10px' ,color:'#172446', cursor: 'pointer'}} onClick={toggleAddModal}/>
  </div>
  
  
  {/* add blog Modal */}
<Modal show={showAddModal} onHide={toggleAddModal} backdrop="static" >
    <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
      <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}>Add Success Stories</Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ backgroundColor: '#f8f9fa' }}>
    <Form noValidate validated={validated} onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
      

{/* row 1 -  title*/}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="Title">
    <Form.Label style={{ marginBottom: '5px' }}>Name</Form.Label>
    <Form.Control name="Title"  value={successDetails.Title} onChange={handleChange}  isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid Title.</Form.Control.Feedback>
  </Form.Group>
</div>
</div>

{/* row 3 - ExternalUrl */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="ExternalUrl">
    <Form.Label style={{ marginBottom: '5px' }}> Web Address</Form.Label>
    <Form.Control name="ExternalUrl"  value={successDetails.ExternalUrl} onChange={handleChange}  isInvalid={errors.ExternalUrl} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid address</Form.Control.Feedback>
  </Form.Group>
</div>
</div>

{/* row 2 - Content */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="Content">
    <Form.Label style={{ marginBottom: '5px' }}>Content</Form.Label>
    <Form.Control as="textarea"  rows={4}  name="Content" value={successDetails.Content} onChange={handleChange}  isInvalid={errors.Content} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%' }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid Content.</Form.Control.Feedback>
  </Form.Group>
</div>
</div>


{/* row 4 - Image */}

 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
      <div style={{ marginRight: '10px', flex: '1' }}>
      <label htmlFor="logo" style={{ marginBottom: '5px' }}>Image</label>
      <input type="file" accept="image/png" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
      <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
       {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
      </label>
      </div>
    </div> 



    <div className="d-flex justify-content-end mt-3">
    <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
    {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Saving...
            </>
          ) : (
         'Save'
    )}
    </button>
 
    <button type="button" className="btn btn-secondary" onClick={toggleAddModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
  </div>
  </Form>
    </Modal.Body>
  
  </Modal>


{/* Edit Job Modal */}
  <Modal show={showEditModal} onHide={toggleEditModal} backdrop="static">
<Modal.Header closeButton style={{ backgroundColor: '#f8f9fa' }}>
      <Modal.Title style={{color:'#172446',fontFamily:'segoe ui'}}> Edit Success Stories </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ backgroundColor: '#f8f9fa' }}> 
         
      <Form noValidate validated={validated} onSubmit={handleEditSubmit} style={{ display: 'flex', flexDirection: 'column' }}>

{/* row 1 -  title , isactive*/}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="Title">
    <Form.Label style={{ marginBottom: '5px' }}>Name</Form.Label>
    <Form.Control name="Title"   value={successDetails.Title} onChange={handleChange}  isInvalid={errors.Title} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid Title.</Form.Control.Feedback>
  </Form.Group>
</div>

<div style={{ flex: '1' }}>
      <label style={{ marginBottom: '5px' ,marginLeft:'50px'}}>Status</label>
      <div style={{ display: 'flex', alignItems: 'center',marginLeft:'50px',marginTop:'10px' }}>
      <Form.Check
type="switch"
id="custom-switch"
label="Active"
checked={successDetails.IsActive === 1}
onChange={() => setSuccessDetails({ ...successDetails, IsActive: successDetails.IsActive === 1 ? 0 : 1 })}
/>
</div>
</div>

</div>

{/* row 3 - ExternalUrl */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="ExternalUrl">
    <Form.Label style={{ marginBottom: '5px' }}> Web Address</Form.Label>
    <Form.Control name="ExternalUrl"   value={successDetails.ExternalUrl} onChange={handleChange}  isInvalid={errors.ExternalUrl} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%', minWidth: '150px' }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid address</Form.Control.Feedback>
  </Form.Group>
</div>
</div>

{/* row 2 - Content */}
<div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
<div style={{ marginRight: '10px', flex: '1' }}>
  <Form.Group controlId="Content">
    <Form.Label style={{ marginBottom: '5px' }}>content</Form.Label>
    <Form.Control  as="textarea"     rows={4}   name="Content"  value={successDetails.Content} onChange={handleChange}  isInvalid={errors.Content} style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', width: '100%',  }}/>
    <Form.Control.Feedback type="invalid">Please provide a valid Content.</Form.Control.Feedback>
  </Form.Group>
</div>
</div>


{/* row 4 - Image */}

 <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px' }}>
      <div style={{ marginRight: '10px', flex: '1' }}>
      <label htmlFor="logo" style={{ marginBottom: '5px' }}>Image</label>
      <input type="file" accept="image/png" id="logo" name="logo" onChange={handleLogoChange} style={{ display: 'none' }} />
      <label htmlFor="logo" style={{ display: 'block', width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '16px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', cursor: 'pointer' }}>
       {selectedLogo ? <img src={selectedLogo} alt="Selected" style={{ maxWidth: '100%', maxHeight: '150px' }} /> : 'Choose File'}
      </label>
      </div>
    </div> 



<div className="d-flex justify-content-end mt-3">
    <button type="submit" className="btn" style={{marginRight:'20px',backgroundColor:'#172446', color:'#fff'}}> 
    {isLoading ? (
            <>
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              
              Updating...
            </>
          ) : (
         'Update changes'
    )}
    </button>
 
    <button type="button" className="btn btn-secondary" onClick={toggleEditModal} style={{marginRight:'20px',  color:'#000'}}>Cancel</button>
  </div>

    </Form>        
    </Modal.Body>

  </Modal>

{renderLoading("successStoryListing") || successDetails==null?(
<div style={{ height: '350px', display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '15px' }}>
{successDetails === null ? "No data" : <Spinner animation="border" role="status" style={{ color: '#2855A1' }} />}
</div>
):(
<div style={{height:'600px',overflow:'auto' ,marginTop: '20px'}}>


<Table striped bordered hover style={{ marginTop: '20px' }}>

<thead>
<tr>
 <th>Name</th>
 <th> Web Address</th>
<th> Content</th>
 <th>Image</th>
<th>Status</th> 
<th>Actions</th>  

</tr>
</thead>

<tbody>
{successList?.map((Success, index) => (
  <tr key={index}>
     <td>{Success.Title}</td>
     <td>{Success.ExternalUrl}</td>

    <td>{Success.Content}</td>

    <td>
      {/* {Success.Image} */}
    {Success.Image && (
      <img src={`${process.env.REACT_APP_BASE_URL}${Success.Image}`}  alt="Image" style={{ maxWidth: '50px', maxHeight: '50px' }}/>
    )}
    </td>


    <td>{Success.IsActive === 1 ? 'Active' : 'InActive'}</td>        

     <td>
     <FaEdit
        style={{ marginRight: '5px', color: '#172446', cursor: 'pointer' }}
        onClick={() => toggleEditModal(index)} // Update to toggleEditModal
     />     
      <FaTrash
        style={{ marginLeft: '15px', color: 'red', cursor: 'pointer' }}
        onClick={() => { deleteSuccessStory(Success.Id) }}
        />

<Modal show={showDeleteModal} onHide={handleCancelDelete} backdrop="static">
    <Modal.Header closeButton>
      <Modal.Title>Confirm Deletion</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      Are you sure you want to delete this Success Story?
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={handleCancelDelete}>Cancel</Button>
      <Button variant="danger" onClick={handleDeleteSuccessStory}>Delete</Button>
    </Modal.Footer>
  </Modal>  


    
    </td>
  </tr>
))}
</tbody>

</Table>

</div>
)

}






</div>
        )
}

export default SuccessStory